import { post, get } from "./fetch";

export const getPaymentIntent = (paymentDetails, isLoggedIn) => {
    return isLoggedIn ? post('/api/seller/getPaymentIntent', paymentDetails, true) : post('/api/stripe/getPaymentIntent', paymentDetails, false);
}

export const getPaymentIntentForValidation = (sellerID, amount) => {
    return get(`/api/seller/${sellerID}/payment-intent/${amount}`);
  }